'use client';

import { ICoordinates } from '@app-types/geo';

import { useDailyWeatherForecast } from '@domain/weather/hooks/useDailyWeatherForecast';
import { DailyWeatherCard } from '../WeatherCards/DailyWeatherCard';
import { ContinuousCarousel } from '../Carousels/ContinuousCarousel/ContinuousCarousel';
import { useIsDesktopScreenWidthOrWider } from '@hooks/useScreenWidth';
import { Heading } from '../Heading/Heading';
import { WeatherCarouselLoader } from './WeatherCarouselLoader';

interface IProps {
  coordinates?: ICoordinates;
  title?: string;
}

export const WeatherCarousel = ({ coordinates, title }: IProps) => {
  const isDesktopScreenWidthOrWider = useIsDesktopScreenWidthOrWider();
  const state = useDailyWeatherForecast(coordinates, 6, true);

  const isLoaded = state?.response === 'success';
  const hasFailed = state?.response === 'fail';
  const weatherData = state?.weatherData ?? [];

  if (hasFailed) {
    return null;
  }

  if (!isLoaded) {
    return <WeatherCarouselLoader />;
  }

  return isDesktopScreenWidthOrWider ? (
    <div className="flex flex-col gap-6 sm:gap-10">
      <Heading as="span" variant="sm">
        {title}
      </Heading>
      <div className="flex flex-row gap-4">
        {weatherData.map((dailyData, index) => {
          return <DailyWeatherCard className="grow" key={index} weatherData={dailyData} />;
        })}
      </div>
    </div>
  ) : (
    <ContinuousCarousel
      title={title}
      headingVariant="sm"
      headingAs="span"
      outerClassName="mt-0! md:hidden"
      dataTestId="weather-carousel"
      childrenClassName="w-col-2 min-w-col-2 mr-2 sm:w-col-3 sm:min-col-3"
    >
      {weatherData.map((dailyData, index) => {
        return <DailyWeatherCard key={index} weatherData={dailyData} />;
      })}
    </ContinuousCarousel>
  );
};
